/**
 * Payments Freshness Hook
 */

import { useApiQuery } from '@/hooks/react-query/useApiQuery';
import { portalQueryKeys } from '@/portal/shared/hooks/queryKeys';
import { PaymentsLastUpdatedService } from '../services/payments-last-updated-service';

/** ISO timestamp of the contact's most recent payment change; null when none. */
export const usePaymentsLastUpdated = () => {
  return useApiQuery<string | null>(
    portalQueryKeys.transactions.paymentsLastUpdated(),
    () => PaymentsLastUpdatedService.getLastUpdated()
  );
};
